import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AutoLogout = () => {
    const navigate = useNavigate();
    // Set timeout to 30 minutes (1800000 ms) - can be adjusted to 15 mins (900000 ms)
    const logoutTime = 30 * 60 * 1000;
    const warningTime = 5 * 60 * 1000; // Show warning 5 minutes before logout
    // const logoutTime = 2 * 60 * 1000;
    // const warningTime = 1 * 60 * 1000; // Show warning 5 minutes before logout

    useEffect(() => {
        let logoutTimer;
        let warningTimer;
        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

        const resetTimers = () => {
            clearTimeout(logoutTimer);
            clearTimeout(warningTimer);

            // Set new timers
            warningTimer = setTimeout(showWarning, logoutTime - warningTime);
            logoutTimer = setTimeout(logout, logoutTime);
        };

        const showWarning = () => {
            toast.warning(`You will be logged out in 5 minutes due to inactivity.`, {
                autoClose: false,
                closeOnClick: false,
                draggable: false,
            });
        };

        const logout = () => {
            localStorage.removeItem("crymadx");
            toast.dismiss(); // Clear any active toasts
            toast.info("You have been logged out due to inactivity.");
            navigate("/login");
        };

        resetTimers();

        // Add event listeners for user activity
        events.forEach(event => {
            window.addEventListener(event, resetTimers);
        });

        // Cleanup function
        return () => {
            clearTimeout(logoutTimer);
            clearTimeout(warningTimer);
            events.forEach(event => {
                window.removeEventListener(event, resetTimers);
            });
            toast.dismiss();
        };
    }, [navigate]);

    return null; // This component doesn't render anything
};

export default AutoLogout;